import React, { useState, useEffect } from 'react'
import { isMobile } from 'react-device-detect'
import { AddMailButtonWrapper, AddMailButtonWrappedRight, MailsWrapper } from '../ClientMailsTab/styles'
import { useLazyQuery } from '@apollo/client'
import { USER_MAILS_HISTORY, UserMailsHistoryResult, UserMailsHistoryVariables } from 'graphql/mails/queries'
import { displayErrors } from 'globals/graphql'
import Mail from 'globals/models/Mail'
import { Domiciliation } from 'globals/models/Domiciliation'
import { Paginator, SearchBar } from 'components'
import AddMail from 'pages/AddMail'
import ClientMails from 'pages/ClientDetails/components/ClientMails'
import ClientMailsMobile from 'pages/ClientDetails/components/ClientMailsMobile'
import MailDetails from 'pages/ClientDetails/components/MailDetails'

interface IProps {
  domiciliation: Domiciliation
}

// this is very similar to ClientMailsTab, maybe we could factorize it
const ClientMailsHistoryTab = (props: IProps) => {
  const pageSize = 10

  const { domiciliation } = props
  const [mailDetails, setMailDetails] = useState<Mail | null>(null)
  const [showMailDetails, setShowMailDetails] = useState(false)
  const [showAddMail, setShowAddMail] = useState(false)
  const [isFromUpdateMail, setIsFromUpdateMail] = useState<boolean | undefined>(undefined)
  const [selectedMailsIds, setSelectedMailsIds] = useState<React.Key[]>([])
  const [searchParams, setSearchParams] = useState({ searchTerm: '', currentPage: 1 })

  const onMailClicked = (mail: Mail) => {
    setMailDetails(mail)
    setShowMailDetails(true)
  }

  const [fetchMails, { loading, data, refetch }] = useLazyQuery<UserMailsHistoryResult, UserMailsHistoryVariables>(
    USER_MAILS_HISTORY,
    { ...displayErrors }
  )

  const searchMails = () => {
    fetchMails({
      variables: {
        search: searchParams.searchTerm,
        domiciliationId: domiciliation.id,
        page: searchParams.currentPage,
        pageLength: pageSize
      },
      ...displayErrors
    })
  }

  useEffect(searchMails, [searchParams])
  useEffect(searchMails, [])

  return (
    <MailsWrapper>
      <>
        <AddMailButtonWrapper>
          <div />

          <AddMailButtonWrappedRight>
            <SearchBar
              onSearch={() => null}
              onChange={(value: string) => setSearchParams({ searchTerm: value, currentPage: 1 })}
              value={searchParams.searchTerm}
              hideFilters
              placeholder={'Rechercher ID'}
              marginBottom={false}
              height={'31px'}
              backgroundColor={'#F0F1F3'}
            />

            <Paginator
              currentPage={data?.userMailsHistory?.pagination?.currentPage || 1}
              totalPages={data?.userMailsHistory?.pagination?.totalPages || 1}
              onChangePage={(page: number) => setSearchParams({ ...searchParams, currentPage: page })}
              disabled={loading}
            />
          </AddMailButtonWrappedRight>
        </AddMailButtonWrapper>

        {data?.userMailsHistory &&
          (isMobile ? (
            <ClientMailsMobile
              mails={data.userMailsHistory.userMailsHistory}
              selectedMailsIds={selectedMailsIds}
              setSelectedMailsIds={setSelectedMailsIds}
              onMailClicked={onMailClicked}
            />
          ) : (
            <ClientMails
              data={data.userMailsHistory.userMailsHistory}
              selectedMailsIds={selectedMailsIds}
              setSelectedMailsIds={setSelectedMailsIds}
              onMailClicked={onMailClicked}
              currentPage={searchParams.currentPage}
              pageSize={pageSize}
              alwaysHideCheckboxes={true}
              alwaysShowCheckboxes={false}
              lineStyle={'clientHistory'}
            />
          ))}
      </>

      <MailDetails
        domiciliation={domiciliation}
        mail={mailDetails}
        visible={showMailDetails}
        onClose={() => setShowMailDetails(false)}
        setShowAddMail={setShowAddMail}
        setIsFromUpdateMail={setIsFromUpdateMail}
        refetch={refetch}
      />

      <AddMail
        domiciliation={domiciliation}
        visible={showAddMail}
        onClose={() => setShowAddMail(false)}
        isFromUpdateMail={isFromUpdateMail}
        setIsFromUpdateMail={setIsFromUpdateMail}
        refetch={refetch}
      />
    </MailsWrapper>
  )
}

export default ClientMailsHistoryTab
